import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/X';
import SitemarkIcon from './SitemarkIcon';
import { useEdc } from '../edc/EdcContext';

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
      {'Copyright © '}
      <Link color="text.secondary" href="https://mui.com/">
        Symlyne
      </Link>
      &nbsp;
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer({ onSelectView, onShowTileForm, onShowScoreForm, onShowEmailThankYou }) {
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const { edcMode } = useEdc();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const res = await fetch('/.netlify/functions/submit-form', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        form: 'subscribe',
        email: email
      }),
    });

    setLoading(false);

    if (!res.ok) {
      alert('Invalid key or failed submission');
      return;
    }

    const data = await res.json();
    console.log('✅ Submitted: new', data);
    if (onShowEmailThankYou) onShowEmailThankYou();

  };
  return (
    <React.Fragment>
      <Divider sx={{border: '3px solid #106a41'}} />
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 4, sm: 8 },
          py: { xs: 8, sm: 10 },
          textAlign: { sm: 'center', md: 'left' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
              minWidth: { xs: '100%', sm: '60%' },
            }}
          >
            <Box sx={{ width: { xs: '100%', sm: '60%' } }}>
              <SitemarkIcon />
              <Typography
                variant="body2"
                gutterBottom
                sx={{ fontWeight: 600, mt: 2 }}
              >
                {edcMode ? 'Join Headbanger Union Local 808' : 'Join Golf Boys'}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                {edcMode
                  ? 'Get your rave tag. Lock in sets, find your crew, never miss a drop.'
                  : 'Get your battle tag using an email. Start conquering today!'}
              </Typography>
              <InputLabel htmlFor="email-newsletter">Email</InputLabel>
              <Stack direction="row" spacing={1} useFlexGap>
                <TextField
                  id="email-newsletter"
                  hiddenLabel
                  size="small"
                  variant="outlined"
                  fullWidth
                  aria-label="Enter your email address"
                  placeholder="Your email address"
                  value={email}
                  className="email-input"
                  onChange={(e) => setEmail(e.target.value)}
                  slotProps={{
                    htmlInput: {
                      autoComplete: 'off',
                      'aria-label': 'Enter your email address',
                    },
                  }}
                  sx={{ width: '250px' }}
                />
                <Button
                  onClick={handleSubmit}
                  disabled={loading}
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ flexShrink: 0 }}
                >
                  Join
                </Button>
              </Stack>
            </Box>
          </Box>
       {/*  <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
              Tee Times
            </Typography>
            <Link color="text.secondary" variant="body2" href="#">
              Upcoming
            </Link>
            <Link color="text.secondary" variant="body2" href="#">
              Previous Rounds
            </Link>
            <Link color="text.secondary" variant="body2" href="#">
              Propose Time
            </Link>
          </Box>
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
              Scores
            </Typography>
            <Link color="text.secondary" variant="body2" href="#">
              Low Scores
            </Link>
            <Link color="text.secondary" variant="body2" href="#">
              High Scores
            </Link>
          </Box> */}
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
              {edcMode ? 'Lineup' : 'Battles'}
            </Typography>
            {edcMode ? (
              <>
                <Link onClick={() => { onSelectView('bass-planner'); }} color="text.secondary" variant="body2" href="#">
                  Bass Pod
                </Link>
                <Link onClick={() => { onSelectView('bass-planner'); }} color="text.secondary" variant="body2" href="#">
                  Cosmic Meadow
                </Link>
                <Link onClick={() => { onSelectView('bass-planner'); }} color="text.secondary" variant="body2" href="#">
                  Kinetic Field
                </Link>
                <Link onClick={onShowScoreForm} color="text.secondary" variant="body2" href="#">
                  I'm Going
                </Link>
              </>
            ) : (
              <>
                <Link onClick={() => { onSelectView('battle-for-em'); }} color="text.secondary" variant="body2" href="#">
                  Emerald
                </Link>
                <Link onClick={() => { onSelectView('battle-for-muni'); }} color="text.secondary" variant="body2" href="#">
                  Muni
                </Link>
                <Link onClick={onShowScoreForm} color="text.secondary" variant="body2" href="#">
                  Claim Holes
                </Link>
              </>
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            pt: { xs: 4, sm: 8 },
            width: '100%',
            borderTop: '1px solid',
            borderColor: 'divider',
          }}
        >
          <div>
            <Link color="text.secondary" variant="body2" href="#">
              Privacy Policy
            </Link>
            <Typography sx={{ display: 'inline', mx: 0.5, opacity: 0.5 }}>
              &nbsp;•&nbsp;
            </Typography>
            <Link color="text.secondary" variant="body2" href="#">
              Terms of Service
            </Link>
            <Copyright />
          </div>
        </Box>
      </Container>
    </React.Fragment>
  );
}
